import axios from '../service/axios/axios'

export default {
  //获取常用回复列表
  replyList() {
    return axios({
      method: 'post',
      url: 'platform/template/replyList',
    })
  },
  //获取常用回复
  replyItem({ type_id }) {
    return axios({
      method: 'post',
      url: 'platform/template/replyItem',
      data: { type_id },
    })
  },
  //编辑常用回复
  editReply(data) {
    return axios({
      method: 'post',
      url: 'platform/template/editReply',
      data: data,
    })
  },
  //获取主诉列表
  getSymptomList(data) {
    return axios({
      method: 'post',
      url: 'platform/template/getSymptomList',
      data: data,
    })
  },
  //检测主诉名是否重复
  checkSymptomName({ symptom_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/checkSymptomName',
      data: { symptom_name },
    })
  },
  //保存主诉
  saveSymptom({ symptom_id, symptom_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/saveSymptom',
      data: { symptom_id, symptom_name },
    })
  },
  //删除主诉
  deleteSymptom({ symptom_id }) {
    return axios({
      method: 'post',
      url: 'platform/template/deleteSymptom',
      data: { symptom_id },
    })
  },
  //获取病症列表
  getDiseaseList(data) {
    return axios({
      method: 'post',
      url: 'platform/template/getDiseaseList',
      data: data,
    })
  },
  //检测病症名是否重复
  checkDiseaseName({ disease_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/checkDiseaseName',
      data: { disease_name },
    })
  },
  //保存病症
  saveDisease({ disease_id, disease_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/saveDisease',
      data: { disease_id, disease_name },
    })
  },
  //删除病症
  deleteDisease({ disease_id }) {
    return axios({
      method: 'post',
      url: 'platform/template/deleteDisease',
      data: { disease_id },
    })
  },
  //获取煎法列表
  getDecoctingList(data) {
    return axios({
      method: 'post',
      url: 'platform/template/getDecoctingList',
      data: data,
    })
  },
  //检测煎法名是否重复
  checkDecoctingName({ decocting_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/checkDecoctingName',
      data: { decocting_name },
    })
  },
  //保存煎法
  saveDecocting({ decocting_id, decocting_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/saveDecocting',
      data: { decocting_id, decocting_name },
    })
  },
  //删除煎法
  deleteDecocting({ decocting_id }) {
    return axios({
      method: 'post',
      url: 'platform/template/deleteDecocting',
      data: { decocting_id },
    })
  },
  //获取用法列表
  getUseList(data) {
    return axios({
      method: 'post',
      url: 'platform/template/getUseList',
      data: data,
    })
  },
  //检测用法名是否重复
  checkUseName({ use_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/checkUseName',
      data: { use_name },
    })
  },
  //保存用法
  saveUse({ use_id, use_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/saveUse',
      data: { use_id, use_name },
    })
  },
  //删除用法
  deleteUse({ use_id }) {
    return axios({
      method: 'post',
      url: 'platform/template/deleteUse',
      data: { use_id },
    })
  },
  // 修改用法类型
  saveUseType(data) {
    return axios({
      method: 'post',
      url: 'platform/template/saveUseType',
      data: data,
    })
  },
  //获取禁忌列表
  getTabooList(data) {
    return axios({
      method: 'post',
      url: 'platform/template/getTabooList',
      data: data,
    })
  },
  //检测禁忌名是否重复
  checkTabooName({ taboo_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/checkTabooName',
      data: { taboo_name },
    })
  },
  //保存禁忌
  saveTaboo({ taboo_id, taboo_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/saveTaboo',
      data: { taboo_id, taboo_name },
    })
  },
  //删除禁忌
  deleteTaboo({ taboo_id }) {
    return axios({
      method: 'post',
      url: 'platform/template/deleteTaboo',
      data: { taboo_id },
    })
  },
  //获取处方库模板列表
  getTcmTemplateList(data) {
    return axios({
      method: 'post',
      url: 'platform/template/getTcmTemplateList',
      data: data,
    })
  },
  //修改处方模板状态（1 启用，2 禁用，3 删除）
  changeTcmTemplateStatus({ tcm_template_id, tcm_template_status }) {
    return axios({
      method: 'post',
      url: 'platform/template/changeTcmTemplateStatus',
      data: { tcm_template_id, tcm_template_status },
    })
  },
  //获取处方模板详情
  getTcmTemplateInfo({ tcm_template_id }) {
    return axios({
      method: 'post',
      url: 'platform/template/getTcmTemplateInfo',
      data: { tcm_template_id },
    })
  },
  // 获取处方模板引用列表
  gettemplatecitationslist(data) {
    return axios({
      method: 'post',
      url: 'platform/template/gettemplatecitationslist',
      data: data,
    })
  },
  // 导出处方模板引用列表
  exporttemplatecitationslist(data) {
    return axios({
      method: 'post',
      url: 'platform/template/exporttemplatecitationslist',
      data: data,
    })
  },
  //获取药品煎法
  getSystemDecocting() {
    return axios({
      method: 'post',
      url: 'platform/template/getSystemDecocting',
    })
  },
  //获取处方用法
  getSystemUse() {
    return axios({
      method: 'post',
      url: 'platform/template/getSystemUse',
    })
  },
  //获取处方禁忌
  getSystemTaboo() {
    return axios({
      method: 'post',
      url: 'platform/template/getSystemTaboo',
    })
  },
  // 获取药品名称列表
  getSystemDrugTcmList({ simple_pname }) {
    return axios({
      method: 'post',
      url: 'platform/template/getSystemDrugTcmList',
      data: { simple_pname },
    })
  },
  //获取诊断病症列表
  getSystemDiseaseList({ disease_name }) {
    return axios({
      method: 'post',
      url: 'platform/template/getSystemDiseaseList',
      data: { disease_name },
    })
  },
  //提交处方模板编辑
  saveTcmTemplate(data) {
    return axios({
      method: 'post',
      url: 'platform/template/saveTcmTemplate',
      data: data,
    })
  },

  /* 肝肾毒性药材 */
  // 肝肾毒性药材列表
  poisonDrugLists(data) {
    return axios({
      method: 'post',
      url: 'platform/goods/poisonDrugLists',
      data: data,
    })
  },
  // 编辑肝肾毒性药材
  savePoisonDrug(data) {
    return axios({
      method: 'post',
      url: 'platform/goods/savePoisonDrug',
      data: data,
    })
  },
  // 删除肝肾毒性药材
  delPoisonDrug(data) {
    return axios({
      method: 'post',
      url: 'platform/goods/delPoisonDrug',
      data: data,
    })
  },
  /* 医生自建处方模板 */
  // 医生自建处方模板列表
  doctorTcmTemplateList(data) {
    return axios({
      method: 'post',
      url: 'platform/Template/doctorTcmTemplateList',
      data: data,
    })
  },
  // 医生详情模板列表
  doctorTcmTemplateInfoList(data) {
    return axios({
      method: 'post',
      url: 'platform/template/doctorTcmTemplateInfoList',
      data: data,
    })
  },
  // 获取医生信息
  getDoctorInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/sdepartment/getDoctorInfo',
      data: data,
    })
  },
  // 获取医生是否有模板
  doctorTcmTemplateImportInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/template/doctorTcmTemplateImportInfo',
      data: data,
    })
  },
  // 医生从处方库导入模板
  tcmTemplateImportDoctor(data) {
    return axios({
      method: 'post',
      url: 'platform/template/tcmTemplateImportDoctor',
      data: data,
    })
  },
  // 添加或修改医生模版
  saveDoctorTcmTemplate(data) {
    return axios({
      method: 'post',
      url: 'platform/template/saveDoctorTcmTemplate',
      data: data,
    })
  },
  // 获取医生模板详情
  getDoctorTcmTemplateInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/template/getDoctorTcmTemplateInfo',
      data: data,
    })
  },
  // 删除医生处方模板
  delDoctorTcmTemplate(data) {
    return axios({
      method: 'post',
      url: 'platform/template/delDoctorTcmTemplate',
      data: data,
    })
  },
  /* 敏感词库列表---start */
  // 获取敏感词列表
  getSensitiveKeywordsList(data) {
    return axios({
      method: 'post',
      url: 'platform/Sensitivekeywords/getSensitiveKeywordsList',
      data: data,
    })
  },
  // 新增敏感词
  addSensitiveKeywords(data) {
    return axios({
      method: 'post',
      url: 'platform/Sensitivekeywords/addSensitiveKeywords',
      data: data,
    })
  },
  // 删除敏感词
  deleteSensitiveKeywords(data) {
    return axios({
      method: 'post',
      url: 'platform/Sensitivekeywords/deleteSensitiveKeywords',
      data: data,
    })
  },
  // 新增敏感词规则
  addSensitiveKeywordsRule(data) {
    return axios({
      method: 'post',
      url: 'platform/Sensitivekeywords/addSensitiveKeywordsRule',
      data: data,
    })
  },
  // 删除敏感词规则
  deleteSensitiveKeywordsRule(data) {
    return axios({
      method: 'post',
      url: 'platform/Sensitivekeywords/deleteSensitiveKeywordsRule',
      data: data,
    })
  },
  // 获取敏感词规则列表
  getSensitiveKeywordsRuleList(data) {
    return axios({
      method: 'post',
      url: 'platform/Sensitivekeywords/getSensitiveKeywordsRuleList',
      data: data,
    })
  },
  // 获取敏感词拦截记录
  getSensitiveKeywordsCheckLogList(data) {
    return axios({
      method: 'post',
      url: 'platform/Sensitivekeywords/getSensitiveKeywordsCheckLogList',
      data: data,
    })
  },
  // 获取敏感词类型
  getsensitivekeywordstype(data) {
    return axios({
      method: 'post',
      url: 'platform/sensitivekeywords/getsensitivekeywordstype',
      data: data,
    })
  },
  // 获取敏感词使用场景
  getSensitiveKeywordsLimit(data) {
    return axios({
      method: 'post',
      url: 'platform/sensitivekeywords/getSensitiveKeywordsLimit',
      data: data,
    })
  },
  /* 敏感词库列表---end */
  /* 辅料通用名---start */
  // 辅料通用名列表
  materialTcmList(data) {
    return axios({
      method: 'post',
      url: '/platform/template/materialTcmList',
      data: data,
    })
  },
  // 辅料通用名新增
  materialTcmAdd(data) {
    return axios({
      method: 'post',
      url: '/platform/template/materialTcmAdd',
      data: data,
    })
  },
  // 辅料通用名修改
  materialTcmUpdate(data) {
    return axios({
      method: 'post',
      url: '/platform/template/materialTcmUpdate',
      data: data,
    })
  },
  // 辅料通用名删除
  materialTcmDel(data) {
    return axios({
      method: 'post',
      url: '/platform/template/materialTcmDel',
      data: data,
    })
  },
  // 辅料分类
  goodsMaterialType(data) {
    return axios({
      method: 'post',
      url: '/platform/template/goodsMaterialType',
      data: data,
    })
  },
  /* 辅料通用名---end */
}
